import { StorageUtil } from '../../../../shared/utils/storage';
import { EmailInboxFilters } from '../../type';

const emailInboxFilterKey = 'email-inbox-filters';
const emailInboxMetaDetailsKey = 'email-inbox-meta-details';

export const setEmailInboxFiltersInLocalStore = (
  filters: EmailInboxFilters,
) => {
  StorageUtil.setItem(emailInboxFilterKey, JSON.stringify(filters));
};

export const getEmailInboxFiltersFromLocalStore = (): EmailInboxFilters =>
  JSON.parse(StorageUtil.getItem(emailInboxFilterKey));

export const removeEmailInboxFiltersFromLocalStore = (): void => {
  StorageUtil.removeItem(emailInboxFilterKey);
};

export const getEmailInboxMetaDetailsFromLocalStore = () =>
  JSON.parse(StorageUtil.getItem(emailInboxMetaDetailsKey));
export const setEmailInboxMetaDetailsInLocalStore = (metaDetails: any) =>
  StorageUtil.setItem(emailInboxMetaDetailsKey, JSON.stringify(metaDetails));
export const removeEmailInboxMetaDetailsFromLocalStore = () => {
  StorageUtil.removeItem(emailInboxMetaDetailsKey);
};
